export default class MembershipStart extends HTMLDivElement {

    constructor() {
        super();
    }

    get withdrawalSelect() {
        return this.querySelector("[data-membership-start='withdrawal-select'] select");
    }

    get startSelect() {
        return this.querySelector("[data-membership-start='start-select'] select");
    }

    get withdrawalConfirm() {
        return this.querySelector("[data-membership-start='withdrawal-confirm']");
    }

    get withdrawalConfirmCheckbox() {
        return this.querySelector("[data-membership-start='withdrawal-confirm'] input");
    }
    
    connectedCallback() {
        this.withdrawalSelect.addEventListener("change", (event) => {
            if (event.target.value) {
                this.startSelect.classList.remove("no-withdrawal");
                this.startSelect.classList.add("withdrawal");
                this.startSelect.selectedIndex = 0;
                this.withdrawalConfirm.classList.remove("hidden");
            }
            else {
                this.startSelect.classList.remove("withdrawal");
                this.startSelect.classList.add("no-withdrawal");
                this.startSelect.selectedIndex = 0;
                this.withdrawalConfirm.classList.add("hidden");
                this.withdrawalConfirmCheckbox.checked = false;
            }
        });     
    }
}

customElements.define('membership-start', MembershipStart, { extends: "div" });